import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Route, withRouter } from "react-router-dom";

import Footer from "@bit/fabfitfun.shared.global.footer";
import Header from "@bit/fabfitfun.shared.global.header";

import { setViewWidth } from "./actions/viewActions";

import Home from "../src/Components/Home/Home";
import "./App.css";
import "./globals.css";
import "./Shared/fontAwesome/css/fontawesome.min.css";
import "./Shared/fontAwesome/css/light.min.css";
import "./Shared/fontAwesome/css/regular.min.css";
import "./Shared/fontAwesome/css/solid.min.css";

import headerRoutes from "./utils/headerRoutes";

class App extends Component {
  componentWillMount() {
    window.addEventListener("resize", this.handleResize);
  }

  handleResize = () => this.props.setViewWidth(window.innerWidth);

  render() {
    return (
      <div className="App">
        <Header routes={headerRoutes} />
        <main className="add-ons">
          <Route path="*" component={Home} />
        </main>
        <Footer />
      </div>
    );
  }
}

const mS = state => ({
  isMobile: state.view.isMobile
});

const mD = dispatch =>
  bindActionCreators(
    {
      setViewWidth
    },
    dispatch
  );

export default withRouter(
  connect(
    mS,
    mD
  )(App)
);
